import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import seo from "@/seo/pages.json";

const SITE = seo.siteName;
const DEFAULT = seo.pages.find((p) => p.path === "/");

function setMeta(attr, key, content) {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) { el = document.createElement("meta"); el.setAttribute(attr, key); document.head.appendChild(el); }
  el.setAttribute("content", content);
}

function setJsonLd(data) {
  let el = document.getElementById("seo-jsonld");
  if (!data) { el?.remove(); return; }
  if (!el) { el = document.createElement("script"); el.id = "seo-jsonld"; el.type = "application/ld+json"; document.head.appendChild(el); }
  el.textContent = JSON.stringify(data);
}

export function useSeo(overrides = {}) {
  const { pathname, search } = useLocation();
  const page = seo.pages.find((p) => p.path === pathname) || seo.pages.find((p) => pathname.startsWith(p.path + "/") && p.path !== "/") || DEFAULT;
  const title = overrides.title || page.title;
  const description = overrides.description || page.description;
  const noindex = overrides.noindex ?? Boolean(page.noindex);
  const image = overrides.image || "";
  const type = overrides.type || "website";
  const jsonLd = overrides.jsonLd ? JSON.stringify(overrides.jsonLd) : "";
  const canonicalSearch = overrides.keepSearch ? search : "";
  useEffect(() => {
    const full = `${title} | ${SITE}`;
    const url = `${window.location.origin}${pathname}${canonicalSearch}`;
    const img = image || `${window.location.origin}/og-image.jpg`;
    document.title = full;
    setMeta("name", "description", description);
    setMeta("name", "robots", noindex ? "noindex, nofollow" : "index, follow");
    setMeta("property", "og:site_name", SITE);
    setMeta("property", "og:title", full);
    setMeta("property", "og:description", description);
    setMeta("property", "og:url", url);
    setMeta("property", "og:type", type);
    setMeta("property", "og:image", img);
    setMeta("name", "twitter:card", "summary_large_image");
    setMeta("name", "twitter:title", full);
    setMeta("name", "twitter:description", description);
    setMeta("name", "twitter:image", img);
    let canon = document.head.querySelector('link[rel="canonical"]');
    if (!canon) { canon = document.createElement("link"); canon.setAttribute("rel", "canonical"); document.head.appendChild(canon); }
    canon.setAttribute("href", url);
    setJsonLd(jsonLd ? JSON.parse(jsonLd) : null);
  }, [title, description, noindex, pathname, image, type, jsonLd, canonicalSearch]);
}
